export default __webpack_public_path__ + "static/media/openraise_0003_thumb.6b9e2012.jpg";